module.exports = __webpack_public_path__ + "static/media/clicToPayLogo.a285551b.ico";